import { Listeners } from './utils.js';

class CosBanner extends HTMLElement {
  constructor() {
    super();
    this.video = null;
    this.listeners = new Listeners();
    this.settings = JSON.parse(this.getAttribute('data-settings')) || {};    
  }

  connectedCallback() {
    this.listenForScroll();
  }

  disconnectedCallback() {
    this.listeners.removeAll();
  }

  listenForScroll() {
    if (!this.getVideoSrc()) return;

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].intersectionRatio <= 0) {
        this.pauseVideo();
      } else {
        (!this.video) ? this.initVideo() : this.playVideo();
      }
    }, {
      rootMargin: '20% 80%',
      threshold: .1
    });

    observer.observe(this);
  }
  
  initVideo() {
    this.video = document.createElement('video');
    this.video.muted = true;
    this.video.loop = 'loop';
    this.video.playsinline = true;
    this.video.setAttribute('preload', 'auto');
    this.video.setAttribute('muted', '');
    this.video.setAttribute('loop', '');
    this.video.setAttribute('playsinline', '');
    this.video.src = this.getVideoSrc();

    const videoWrapper = document.createElement('div');
    videoWrapper.classList.add('video-wrapper', 'images-wrap');
    videoWrapper.appendChild(this.video);

    const imagesWrapp = this.querySelector('.images-wrap');
    (imagesWrapp) ? imagesWrapp.after(videoWrapper) : this.querySelector('.banner').prepend(videoWrapper);
    
    this.listenForOrientationChange();
    this.initControls();
    
    this.playVideo(imagesWrapp);
  }

  listenForOrientationChange() {
    if (!screen) return;
    if (!screen.orientation) return;
    if (!this.video) return;

    screen.orientation.addEventListener("change", (event) => {
      const type = event.target.type;
      const angle = event.target.angle;
      const typeForVideo = (type === 'portrait-primary') ? 'mobile' : 'desktop';

      this.video.src = this.getVideoSrc(typeForVideo);
      this.playVideo();
      console.log(`ScreenOrientation change: ${type}, ${angle} degrees.`);
    });
  }

  getVideoSrc(typeForVideo) {
    return this.settings.videos ? this.settings.videos[typeForVideo || window.matchMedia("(orientation: landscape)").matches ? 'desktop' : 'mobile'].src : null;
  }

  playVideo(imagesWrapp) {
    if (!this.video) return;
    this.video.play()
    .then(() => {
      console.log('Video played');
      if (imagesWrapp) imagesWrapp.remove();
    })
    .catch((err) => {
      console.log(err.name, err.message);
      // Video couldn't play, low power play button showing.
      if (imagesWrapp) {
        const image = imagesWrapp.querySelector('img');
        if (image) image.classList.remove('hidden');
      }
      if (!this.playPauseBtn) return;
      this.playPauseBtn.classList.remove('hidden');      
    });
  }

  pauseVideo() {
    if (!this.video) return;
    this.video.pause();
  }

  hasAudio() {
    if (!this.video) return;
    return this.video.mozHasAudio ||
    Boolean(this.video.webkitAudioDecodedByteCount) ||
    Boolean(this.video.audioTracks && this.video.audioTracks.length);
  }

  initControls() {
    if (!this.settings.video_controls.play_pause_btn && !this.settings.video_controls.sound_btn) return; 

    const controls = document.createElement('div');
    controls.classList.add('video-controls', 'flex', 'btn--group', 'gap15', 'align-center', 'justify-center', 'text-center');

    this.initPlayPauseBtn(controls);
    this.initSoundBtn(controls);

    this.video.after(controls);
  }

  initPlayPauseBtn(controls) {
    if (!this.settings.video_controls.play_pause_btn) return;
    
    // this.video.addEventListener('suspend', () => {
    //   console.log('suspend');
    // });

    this.playPauseBtn = document.createElement('button');
    this.playPauseBtn.classList.add('btn--icon', 'hidden');
    this.playPauseBtn.innerHTML = this.settings.video_controls.play_pause_btn[this.video.paused ? 'on' : 'off'];

    this.listeners.add(this.playPauseBtn, 'click', () => {
      if (this.video.paused) {
        this.playVideo();
      } else {
        this.pauseVideo();
      }
    });
    this.listeners.add(this.video, 'play', () => {
      this.playPauseBtn.innerHTML = this.settings.video_controls.play_pause_btn.off;
    });
    this.listeners.add(this.video, 'pause', () => {
      this.playPauseBtn.innerHTML = this.settings.video_controls.play_pause_btn.on;
    });

    controls.appendChild(this.playPauseBtn);
  }

  initSoundBtn(controls) {
    if (!this.settings.video_controls.sound_btn) return;
    // if (!this.hasAudio()) return;
    const button = document.createElement('button');
    button.classList.add('btn--icon');
    button.innerHTML = this.settings.video_controls.sound_btn[this.video.muted ? 'off' : 'on'];

    this.listeners.add(button, 'click', () => {
      if (this.video.muted) {
        this.video.muted = false;
      } else {
        this.video.muted = true;
      }
    });
    this.listeners.add(this.video, 'volumechange', () => {
      button.innerHTML = this.settings.video_controls.sound_btn[this.video.muted ? 'off' : 'on'];
    });

    controls.appendChild(button);
  }
}
if (!customElements.get('cos-banner')) customElements.define('cos-banner', CosBanner);